import { drawImage, getContext } from './images.js'
import { ResetMain, PrepareLevel, LevelNumber } from './main.js'
import { PlayTrack, StopTrack } from './music.js'
import { ActivateScene, DeactivateScene } from './sceneController.js'
import * as SFX from './sfx.js'

let ctx = null
var dialogFrame = 0
var dialogLine = 0
var dialog = []
var drawbg = false
var state = 'drawing'

function Reset(diag) {
    diag = diag ? diag : []
    dialogLine = 0
    dialogFrame = 0
    dialog = diag
    state = 'drawing'
}

function AnimationFrame(delta) {
    if (!ctx) {
        ctx = getContext()
    }
    //ctx.clearRect(0, 0, 64, 64)
    if (drawbg) {
        drawImage('title-bg', 0, 0, { x: 0, y: 0, w: 64, h: 64 })
    }

    if (dialog.length > 0 && dialogLine <= dialog.length && state !== 'init') {        
        let text = dialogLine < dialog.length && dialogLine >= 0 ? dialog[dialogLine].slice(0, parseInt(dialogFrame)) : ''
        dialog.forEach((v, index) => {
            if (index === dialogLine) {
                bfontjs.DrawText(ctx, 32 - parseInt(bfontjs.CalculateTextWidth(text, eighties) / 2) + 1, 24 + index * 8, text, '#000000d9', eighties)
                bfontjs.DrawText(ctx, 32 - parseInt(bfontjs.CalculateTextWidth(text, eighties) / 2), 24 + index * 8, text, '#f1f1f1ff', eighties)
            } else if (index < dialogLine) {
                bfontjs.DrawText(ctx, 32 - parseInt(bfontjs.CalculateTextWidth(v, eighties) / 2) + 1, 24 + index * 8, v, '#000000d9', eighties)
                bfontjs.DrawText(ctx, 32 - parseInt(bfontjs.CalculateTextWidth(v, eighties) / 2), 24 + index * 8, v, '#d1d1d1ff', eighties)
            }
        })
    
        if (state === 'drawing') {
            dialogFrame += delta * 0.15
            if (dialogFrame > dialog[dialogLine].length) {
                dialogLine++
                dialogFrame = 0
            }
            if (dialogLine > dialog.length - 1) {
                state = 'waiting'
                setTimeout(() => state = 'erasing', 600)
            }
        } else if (state === 'erasing') {
            dialogFrame -= delta * 0.3
            if (dialogFrame < 0) {
                dialogLine--
                if (dialogLine < 0) {
                    state = 'init'
                    dialogLine = 0
                }
                dialogFrame = dialog[dialogLine].length
            }
        }
    }
}

export { AnimationFrame, Reset }